var lib_core = require("lib-core");

var LayeredShapeData = function (shape, layerIndex) {
    var self = this;

    this.makeObservableTreeNode();

    this.shape = this.value("shape", true);

    this.layerIndex = this.set("layerIndex", true);

    //this.onTopLayer = this.value("onTopLayer", true);

    if(shape != undefined) this.shape(shape);
    // if(onTopLayer != undefined) this.onTopLayer(onTopLayer);
    if(layerIndex != undefined) this.layerIndex.add(layerIndex);

    var addShapeShadows = function () {
        if(self.shape()) {
            self.geometry = self.shape().geometry;
            self.segmentedGeometry = self.shape().segmentedGeometry;
            self.boundingBox = self.shape().boundingBox;
        }
    };

    if(this.shape()) addShapeShadows();
    this.shape.onChange("shapeChanged", addShapeShadows);
};
lib_core.mixin(LayeredShapeData, lib_core.ObservableTreeNode);

lib_core.JsonParser.registerClass(LayeredShapeData, "LayeredShape");

module.exports = LayeredShapeData;

LayeredShapeData.prototype.move = function (vec) {
    return this.shape() && this.shape().move(vec);
};

LayeredShapeData.prototype.rotate = function (angle) {
    return this.shape() && this.shape().rotate(angle);
};

LayeredShapeData.prototype.flip = function (flipline) {
    return this.shape() && this.shape().flip(flipline);
};

LayeredShapeData.prototype.getPos = function() {
    return this.shape().pos();
}

